import { withDependencies } from '@wix/thunderbolt-ioc'
import type { ISiteMembersApi } from 'feature-site-members'
import { SiteMembersApiSymbol } from 'feature-site-members'

interface IViewerManager {
	members: {
		getMemberDetailsInPreview(a: any, b: any, c: boolean): void
		showLoginDialog(): Promise<void>
		showSignUpDialog(): Promise<void>
		hideAuthDialog(): Promise<void>
	}
}

const viewerManagerMembersApiFactory = (siteMembersApi: ISiteMembersApi): IViewerManager => {
	return {
		members: {
			async getMemberDetailsInPreview(onSuccess, onError, refreshCurrentMember) {
				return siteMembersApi.getMemberDetails(refreshCurrentMember).then(onSuccess).catch(onError)
			},
			async showLoginDialog() {
				return new Promise((resolve) => {
					siteMembersApi.showLoginDialog().then(() => resolve())
				})
			},
			async showSignUpDialog() {
				return new Promise((resolve) => {
					siteMembersApi.showSignUpDialog().then(() => resolve())
				})
			},
			async hideAuthDialog() {
				return siteMembersApi.hideAuthDialog()
			},
		},
	}
}
export const ViewerManagerMembersApi = withDependencies([SiteMembersApiSymbol], viewerManagerMembersApiFactory)
